import React from "react";
import { Link } from "react-router-dom";
import {
  Compass,
  Ruler,
  HardHat,
  ClipboardList,
  Map,
  Calculator,
  Hammer,
  Building2,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "../lib/siteData";
import Reveal from "./Reveal";

const ICONS = { Compass, Ruler, HardHat, ClipboardList, Map, Calculator, Hammer, Building2 };

export default function Services() {
  return (
    <section id="services" className="relative py-20 lg:py-28 bg-white overflow-hidden" data-testid="services-section">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#123E73]" />
            <span className="text-xs tracking-[0.3em] font-semibold text-[#123E73]">CAPABILITIES</span>
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.08] tracking-tight text-[#0A192F] max-w-3xl mb-12">
            Eight integrated capabilities. <span className="text-[#123E73]">One accountable partner.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || HardHat;
            return (
              <Reveal key={s.title} delay={i * 60}>
                <Link
                  to="/contact"
                  className="group relative block bg-white border border-slate-200 p-8 h-full transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(18,62,115,0.35)] hover:border-[#123E73]"
                  data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0A192F] text-[#F5A400] mb-6 transition-colors duration-500 group-hover:bg-[#F5A400] group-hover:text-[#0A192F]">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display font-bold text-xl text-[#0A192F] mb-3 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  <div className="mt-6 flex items-center gap-2 text-[#123E73] text-sm font-semibold">
                    <span>Learn more</span>
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>

                  {/* Accent corner */}
                  <span className="absolute top-0 right-0 h-0.5 w-0 bg-[#F5A400] transition-all duration-500 group-hover:w-full" />
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
